export enum OrderType {
  APPROVAL_REQUEST = 'approval_request',
  ORDER = 'order',
  DRAFT = 'draft',
  NOT_CONNECTED = 'not_connected',
  PENDING_PERSONALIZATION = 'pending_personalization',
}
